import React, { useState } from 'react';
import { X } from 'lucide-react';
import * as T from '../ui/inlineTheme';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
  loading?: boolean;
};

const iconBtn: React.CSSProperties = {
  padding: 10,
  border: 'none',
  borderRadius: 10,
  background: 'transparent',
  color: '#a1a1aa',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  WebkitAppearance: 'none',
  appearance: 'none',
};

export function QuickTripModal({ open, onClose, onSubmit, loading }: Props) {
  const [name, setName] = useState('');

  if (!open) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    onSubmit(n);
    setName('');
  };

  const rowBtns: React.CSSProperties = {
    display: 'flex',
    gap: 12,
    marginTop: 4,
  };

  const cancelBtn: React.CSSProperties = {
    ...T.btnSecondary,
    flex: 1,
    opacity: 1,
  };

  const submitBtn: React.CSSProperties = {
    ...T.btnPrimary,
    flex: 1,
    opacity: loading || !name.trim() ? 0.45 : 1,
    cursor: loading || !name.trim() ? 'not-allowed' : 'pointer',
  };

  return (
    <div style={T.modalBackdrop} role="dialog" aria-modal="true" aria-labelledby="quick-trip-title">
      <div style={T.modalPanel}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 12,
          }}
        >
          <h2 id="quick-trip-title" style={{ ...T.h2, fontSize: '1.25rem' }}>
            Quick trip
          </h2>
          <button type="button" onClick={onClose} style={iconBtn} aria-label="Close">
            <X size={22} />
          </button>
        </div>
        <p style={{ ...T.bodyMuted, marginTop: 0, marginBottom: 16 }}>
          Only a name required — dates optional later.
        </p>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Trip name"
            style={T.input}
          />
          <div style={rowBtns}>
            <button type="button" className="sf-btn-secondary" onClick={onClose} style={cancelBtn}>
              Cancel
            </button>
            <button
              type="submit"
              className="sf-btn-primary"
              disabled={loading || !name.trim()}
              style={submitBtn}
            >
              {loading ? 'Creating…' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
